import { SessionProvider } from './SessionProvider';
import { applyDeviceIdHeadersFactory, setUserDeviceIdFactory, setUserHeadersFactory } from './SessionService';

const authProvider = new SessionProvider();

const applyDeviceIdHeaders = applyDeviceIdHeadersFactory(authProvider);
const setUserDeviceId = setUserDeviceIdFactory(authProvider);
const setUserHeaders = setUserHeadersFactory(authProvider);

export default {
  applyDeviceIdHeaders,
  setUserDeviceId,
  setUserHeaders,
};
